module.exports = require('./helpers/bundle-url').getBundleURL('b5eWx') + "logo.c51670a8.svg";